export default "__VITE_ASSET__DvdMhv21__"